
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32 0C14.323 0 0 14.452 0 32c0 17.677 14.323 32 32 32 17.548 0 32-14.323 32-32C64 14.452 49.548 0 32 0zm0 59.871C16.645 59.871 4.129 47.484 4.129 32 4.129 16.774 16.516 4.129 32 4.129c15.226 0 27.871 12.516 27.871 27.871 0 15.355-12.516 27.871-27.871 27.871zm18.194-35.355c.645-.645.645-1.677 0-2.193L49.16 21.16c-.645-.645-1.677-.645-2.193 0L25.806 42.065l-8.903-8.904c-.516-.645-1.548-.645-2.193 0l-1.033 1.033c-.645.645-.645 1.548 0 2.193l11.097 11.226c.516.516 1.549.516 2.194 0l23.226-23.097z","fill":"#1E8C4C"}})])
          )
        }
      }
    